'use strict'

import '../scss/main.scss'

require('lazysizes');

// Image lazy loading
window.lozad = require('lozad');

// Owl carousel
window.owlCarousel = require('owl.carousel')

window.designamite = {

  init()
  {
  	designamite.global.init()
  },
  
  global: require('./methods/global'),

}

designamite.init()